import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { setPatientInformation } from '../../store/slices/metaDataSlice';
import { DoubleNumberCard } from '../../shared/components/numberInput/numberCards/doubleNumberCard';
import { Box } from '@mui/system';

export const AgeView = () => {
  const { patientInformation } = useAppSelector(metaDataSelector);
  const dispatch = useDispatch();
  const maxAgeInYears = 100;
  const maxAgeInMonths = 12;

  const updateDOB = (year: number, month: number, day: number) => {
    const today = new Date();
    let birthYear = today.getFullYear() - year;
    let birthMonth = today.getMonth() + 1 - month;
    if (birthMonth <= 0) {
      birthMonth += 12;
      birthYear -= 1;
    }
    return {
      day: day == 0 ? new Date().getDate() : patientInformation?.dob?.day,
      month: birthMonth,
      year: birthYear
    };
  };

  return (
    <Box margin={'1.25rem 0'}>
      <DoubleNumberCard
        title={'AGE'}
        subHead1={'(years)'}
        subHead2={'(months)'}
        range1={{ min: 0, max: maxAgeInYears }}
        range2={{
          min: 0,
          max:
            patientInformation?.age?.years === maxAgeInYears
              ? 0
              : maxAgeInMonths
        }}
        decimalRequired1={false}
        decimalRequired2={false}
        value1={patientInformation?.age?.years}
        value2={patientInformation?.age?.months}
        setValue1={(val: number) =>
          dispatch(
            setPatientInformation({
              ...patientInformation,
              age: { ...patientInformation.age, years: val },
              dob: updateDOB(
                val,
                patientInformation.age.months,
                patientInformation.dob.day
              )
            })
          )
        }
        setValue2={(val: number) =>
          dispatch(
            setPatientInformation({
              ...patientInformation,
              age: {
                years:
                  val === maxAgeInMonths &&
                  patientInformation.age.years + 1 <= maxAgeInYears
                    ? patientInformation.age.years + 1
                    : patientInformation.age.years,
                months: val === maxAgeInMonths ? 0 : val
              },
              dob: updateDOB(
                patientInformation.age.years,
                val,
                patientInformation.dob.day
              )
            })
          )
        }
      />
    </Box>
  );
};
